import { Box, Title } from '@nimbus-ds/components';
import { VirtualDataList } from 'commons/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { useMetaplansList } from 'domains/Catalog/Subscriptions/hooks';
import {
  MetaplansListMobileRow,
  MetaplansListMobileSkeleton,
} from './components';
import { MetaplansListPageBase } from '../MetaplansListPageBase';

export function MetaplansListMobilePage(): JSX.Element {
  const t = useTranslationCatalog();
  const { metaplans, isLoading, isError, isEmpty, refetch } =
    useMetaplansList();

  const itemContent = (index: number) => (
    <MetaplansListMobileRow metaplan={metaplans[index]} index={index} />
  );

  const handleRefresh = async (): Promise<void> => {
    refetch();
  };

  return (
    <MetaplansListPageBase
      skeleton={<MetaplansListMobileSkeleton />}
      isLoading={isLoading}
      isEmpty={isEmpty}
      isError={isError}
      onRetry={refetch}
    >
      <Box display="flex" flexDirection="column" alignItems="stretch" gap="6">
        <Title as="h4">{t('subscriptions.plansTitle')}</Title>
        <VirtualDataList
          onRefresh={handleRefresh}
          isPullable
          data={metaplans.map((m) => m.id)}
          itemContent={itemContent}
        />
      </Box>
    </MetaplansListPageBase>
  );
}
